import React, { FC } from 'react';
import { View, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';

import { ROW_LAYOUT } from '@v2/pages/dashboard/common/constants/rows';

import { LEGEND_SEPARATOR_HEIGHT } from './constants';
import LegendItem from './components/LegendItem';

export interface DashboardLegendProps extends WithColor {
  testID?: string;
}

const DashboardLegend: FC<DashboardLegendProps> = ({ C, testID }) => {
  return (
    <View
      testID={testID}
      style={{ flexDirection: 'row', alignItems: 'center', paddingHorizontal: scale(ROW_LAYOUT.horizontalPadding) }}
    >
      <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'flex-end', paddingRight: scale(ROW_LAYOUT.horizontalPadding) }}>
        <LegendItem C={C} dotColor="System/Light/Red" label={i18n.t('LOSS')} />
      </View>
      <View
        style={{
          width: StyleSheet.hairlineWidth,
          height: scale(LEGEND_SEPARATOR_HEIGHT),
          backgroundColor: C('Hairline/Light/No trans'),
        }}
      />
      <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'flex-start', paddingLeft: scale(ROW_LAYOUT.horizontalPadding) }}>
        <LegendItem C={C} dotColor="System/Light/Green" label={i18n.t('GAIN')} />
      </View>
      <View style={{ width: scale(ROW_LAYOUT.chevron.size) }} />
    </View>
  );
};

export default ColorWrapper(DashboardLegend);
